import { List } from '../objects/list';
import { Error } from '../objects/error';
import { User } from '../../user/objects/user';
import { Destination } from '../objects/destination';
import { GooglePlace } from '../objects/googlePlace';
import { Currency } from '../../currency/objects/currency';
import { IataCountry } from '../../iata/objects/iataCountry';
import { Preferences } from '../../profile/objects/preferences';
import { DestinationParent } from '../objects/destinationParent';
import { DestinationReduced } from '../objects/destinationReduced';
import { DestinationVersion } from '../objects/destinationVersion';
import { Category } from '../../destinationCategory/objects/destinationCategory';
import { Column } from '../objects/column';

export const SET_CHECKING_NAME_ERROR = 'DESTINATION_SET_CHECKING_NAME_ERROR';
export const ADD_PREFERENCES = 'DESTINATION_ADD_PREFERENCES';
export const DELETE_DESTINATION_PICTURE = 'DESTINATION_DELETE_DESTINATION_PICTURE';
export const MOVE_DOWN_COLUMN = 'DESTINATION_MOVE_DOWN_COLUMN';
export const MOVE_UP_COLUMN = 'DESTINATION_MOVE_UP_COLUMN';
export const RESET_ADD_DESTINATION = 'DESTINATION_RESET_ADD_DESTINATION';
export const RESET_FILTERS = 'DESTINATION_RESET_FILTERS';
export const SET_DESTINATION = 'DESTINATION_SET_DESTINATION';
export const SET_DESTINATION_VERSION = 'DESTINATION_SET_DESTINATION_VERSION';
export const SET_EDIT_STEP = 'DESTINATION_SET_EDIT_STEP';
export const SET_ERRORS = 'DESTINATION_SET_ERRORS';
export const SET_EXPORT_TYPE = 'DESTINATION_SET_EXPORT_TYPE';
export const SET_LIMIT = 'DESTINATION_SET_LIMIT';
export const SET_LIST = 'DESTINATION_SET_LIST';
export const SET_ORDER_BY = 'DESTINATION_SET_ORDER_BY';
export const SET_PAGE = 'DESTINATION_SET_PAGE';
export const SET_PREFERENCES = 'DESTINATION_SET_PREFERENCES';
export const SET_RUNNING = 'DESTINATION_SET_RUNNING';
export const SET_SEARCH = 'DESTINATION_SET_SEARCH';
export const TOGGLE_CANCEL_MODAL = 'DESTINATION_TOGGLE_CANCEL_MODAL';
export const TOGGLE_COLUMN = 'DESTINATION_TOGGLE_COLUMN';
export const TOGGLE_CREATE = 'DESTINATION_TOGGLE_CREATE';
export const TOGGLE_DESTINATION_PICTURES_ORDER = 'DESTINATION_TOGGLE_DESTINATION_PICTURES_ORDER';
export const TOGGLE_EXPORT = 'DESTINATION_TOGGLE_EXPORT';
export const TOGGLE_EXPORT_FULL = 'DESTINATION_TOGGLE_EXPORT_FULL';
export const TOGGLE_FILTERS = 'DESTINATION_TOGGLE_FILTERS';
export const TOGGLE_HOMEPAGE_DISPLAY = 'DESTINATION_TOGGLE_HOMEPAGE_DISPLAY';
export const TOGGLE_AT_SEA = 'DESTINATION_TOGGLE_AT_SEA';
export const TOGGLE_REFRESH = 'DESTINATION_TOGGLE_REFRESH';
export const UPDATE_CALENDAR_ID = 'DESTINATION_UPDATE_CALENDAR_ID';
export const UPDATE_CATEGORY = 'DESTINATION_UPDATE_CATEGORY';
export const UPDATE_CURRENCY = 'DESTINATION_UPDATE_CURRENCY';
export const UPDATE_DESTINATION_NAME_LOCALE = 'DESTINATION_UPDATE_DESTINATION_NAME_LOCALE';
export const UPDATE_DESTINATION_PICTURE_ORDER = 'DESTINATION_UPDATE_DESTINATION_PICTURE_ORDER';
export const UPDATE_DESTINATION_SEARCH = 'DESTINATION_UPDATE_DESTINATION_SEARCH';
export const UPDATE_DESTINATION_TYPE = 'DESTINATION_UPDATE_DESTINATION_TYPE';
export const UPDATE_DURATION_DAYS = 'DESTINATION_UPDATE_DURATION_DAYS';
export const UPDATE_DURATION_HOURS = 'DESTINATION_UPDATE_DURATION_HOURS';
export const UPDATE_DURATION_MINUTES = 'DESTINATION_UPDATE_DURATION_MINUTES';
export const UPDATE_FILTER_COUNTRY = 'DESTINATION_UPDATE_FILTER_COUNTRY';
export const UPDATE_FILTER_CREATED_DATE_GTE = 'DESTINATION_UPDATE_FILTER_CREATED_DATE_GTE';
export const UPDATE_FILTER_CREATED_DATE_LTE = 'DESTINATION_UPDATE_FILTER_CREATED_DATE_LTE';
export const UPDATE_FILTER_CREATOR = 'DESTINATION_UPDATE_FILTER_CREATOR';
export const UPDATE_FILTER_DESTINATION = 'DESTINATION_UPDATE_FILTER_DESTINATION';
export const UPDATE_FILTER_DESTINATION_SEARCH = 'DESTINATION_UPDATE_FILTER_DESTINATION_SEARCH';
export const UPDATE_FILTER_DESTINATION_TYPE = 'DESTINATION_UPDATE_FILTER_DESTINATION_TYPE';
export const UPDATE_FILTER_LAST_AUTHOR = 'DESTINATION_UPDATE_FILTER_LAST_AUTHOR';
export const UPDATE_FILTER_MODIFIED_DATE_GTE = 'DESTINATION_UPDATE_FILTER_MODIFIED_DATE_GTE';
export const UPDATE_FILTER_MODIFIED_DATE_LTE = 'DESTINATION_UPDATE_FILTER_MODIFIED_DATE_LTE';
export const UPDATE_FILTER_PARENT = 'DESTINATION_UPDATE_FILTER_PARENT';
export const UPDATE_FILTER_PERIOD = 'DESTINATION_UPDATE_FILTER_PERIOD';
export const UPDATE_FILTER_PERIOD_TYPE = 'DESTINATION_UPDATE_FILTER_PERIOD_TYPE';
export const UPDATE_FILTER_PICTURES = 'DESTINATION_UPDATE_FILTER_PICTURES';
export const UPDATE_FILTER_STATUS = 'DESTINATION_UPDATE_FILTER_STATUS';
export const UPDATE_GOOGLE_ID = 'DESTINATION_UPDATE_GOOGLE_ID';
export const UPDATE_LATITUDE = 'DESTINATION_UPDATE_LATITUDE';
export const UPDATE_LIST_ITEM_VISIBILITY = 'DESTINATION_UPDATE_LIST_ITEM_VISIBILITY';
export const UPDATE_LOCATION = 'DESTINATION_UPDATE_LOCATION';
export const UPDATE_LONGITUDE = 'DESTINATION_UPDATE_LONGITUDE';
export const UPDATE_MAP = 'DESTINATION_UPDATE_MAP';
export const UPDATE_NAME = 'DESTINATION_UPDATE_NAME';
export const UPDATE_NAME_ERROR = 'DESTINATION_UPDATE_NAME_ERROR';
export const UPDATE_PARENT = 'DESTINATION_UPDATE_PARENT';
export const UPDATE_PUBLISH_DATE = 'DESTINATION_UPDATE_PUBLISH_DATE';
export const UPDATE_PUBLISH_TIME = 'DESTINATION_UPDATE_PUBLISH_TIME';
export const UPDATE_RATING = 'DESTINATION_UPDATE_RATING';
export const UPDATE_TO_USER = 'DESTINATION_UPDATE_TO_USER';
export const UPDATE_VISIBILITY = 'DESTINATION_UPDATE_VISIBILITY';
export const UPDATE_VIDEO_LINK = 'DESTINATION_UPDATE_VIDEO_LINK';
export const UPDATE_EMAIL = 'DESTINATION_UPDATE_EMAIL';
export const UPDATE_ZOOM = 'DESTINATION_UPDATE_ZOOM';
export const INIT_DESTINATION_PICTURE = 'DESTINATION_INIT_DESTINATION_PICTURE';
export const SET_COLUMNS = 'DESTINATION_SET_COLUMNS';

interface SetColumnsAction {
    type: typeof SET_COLUMNS,
    payload: Column[]
}

interface InitDestinationPictureAction {
    type: typeof INIT_DESTINATION_PICTURE
}
interface SetCheckingNameErrorAction {
    type: typeof SET_CHECKING_NAME_ERROR,
    payload: boolean
}
interface AddPreferencesAction {
    type: typeof ADD_PREFERENCES,
    payload: Preferences[]
}

interface DeleteDestinationPictureAction {
    type: typeof DELETE_DESTINATION_PICTURE,
    payload: number
}

interface MoveDownColumnAction {
    type: typeof MOVE_DOWN_COLUMN,
    payload: number
}

interface MoveUpColumnAction {
    type: typeof MOVE_UP_COLUMN,
    payload: number
}

interface ResetAddDestinationAction {
    type: typeof RESET_ADD_DESTINATION
}

interface ResetFiltersAction {
    type: typeof RESET_FILTERS
}

interface SetDestinationAction {
    type: typeof SET_DESTINATION,
    payload: Destination
}

interface SetDestinationVersionAction {
    type: typeof SET_DESTINATION_VERSION,
    payload: DestinationVersion
}

interface SetEditStepAction {
    type: typeof SET_EDIT_STEP,
    payload: string | null
}

interface SetErrorsAction {
    type: typeof SET_ERRORS,
    payload: Error[]
}

interface SetExportTypeAction {
    type: typeof SET_EXPORT_TYPE,
    payload: 'CSV' | 'PDF'
}

interface SetLimitAction {
    type: typeof SET_LIMIT,
    payload: number
}

interface SetListAction {
    type: typeof SET_LIST,
    payload: List
}

interface SetOrderByAction {
    type: typeof SET_ORDER_BY,
    payload: string
}

interface SetPageAction {
    type: typeof SET_PAGE,
    payload: number
}

interface SetPreferencesAction {
    type: typeof SET_PREFERENCES,
    payload: Preferences[]
}

interface SetRunningAction {
    type: typeof SET_RUNNING,
    payload: boolean
}

interface SetSearchAction {
    type: typeof SET_SEARCH,
    payload: string
}

interface ToggleCancelModalAction {
    type: typeof TOGGLE_CANCEL_MODAL
}

interface ToggleColumnAction {
    type: typeof TOGGLE_COLUMN,
    payload: number
}

interface ToggleNewAction {
    type: typeof TOGGLE_CREATE
}

interface ToggleDestinationPicturesOrderAction {
    type: typeof TOGGLE_DESTINATION_PICTURES_ORDER,
}

interface ToggleExportAction {
    type: typeof TOGGLE_EXPORT,
    payload: boolean
}

interface ToggleExportFullAction {
    type: typeof TOGGLE_EXPORT_FULL
}

interface ToggleFiltersAction {
    type: typeof TOGGLE_FILTERS
}

interface ToggleHomePageDisplayAction {
    type: typeof TOGGLE_HOMEPAGE_DISPLAY
}
interface ToggleAtSeaAction {
    type: typeof TOGGLE_AT_SEA
}

interface ToggleRefreshAction {
    type: typeof TOGGLE_REFRESH
}

interface UpdateCalendarIdAction {
    type: typeof UPDATE_CALENDAR_ID,
    payload: IataCountry | null
}

interface UpdateCategoryAction {
    type: typeof UPDATE_CATEGORY,
    payload: Category[]
}

interface UpdateCurrencyAction {
    type: typeof UPDATE_CURRENCY,
    payload: Currency | null
}

interface UpdateDestinationNameLocaleAction {
    type: typeof UPDATE_DESTINATION_NAME_LOCALE,
    payload: {
        value: string,
        id: number,
    }
}

interface UpdateDestinationPictureOrderAction {
    type: typeof UPDATE_DESTINATION_PICTURE_ORDER,
    payload: {
        drag_index: number,
        hover_index: number
    }
}

interface UpdateDestinationSearchAction {
    type: typeof UPDATE_DESTINATION_SEARCH,
    payload: {
        id: number,
        value: null | GooglePlace
    }
}

interface UpdateDestinationTypeAction {
    type: typeof UPDATE_DESTINATION_TYPE,
    payload: number
}

interface UpdateDurationDaysAction {
    type: typeof UPDATE_DURATION_DAYS,
    payload: string | number
}

interface UpdateDurationHoursAction {
    type: typeof UPDATE_DURATION_HOURS,
    payload: number
}

interface UpdateDurationMinutesAction {
    type: typeof UPDATE_DURATION_MINUTES,
    payload: number
}

interface UpdateFilterCountryAction {
    type: typeof UPDATE_FILTER_COUNTRY,
    payload: IataCountry[]
}

interface UpdateFilterCreatedDateGteAction {
    type: typeof UPDATE_FILTER_CREATED_DATE_GTE,
    payload: Date | null
}

interface UpdateFilterCreatedDateLteAction {
    type: typeof UPDATE_FILTER_CREATED_DATE_LTE,
    payload: Date | null
}

interface UpdateFilterCreatorAction {
    type: typeof UPDATE_FILTER_CREATOR,
    payload: string
}

interface UpdateFilterDestinationAction {
    type: typeof UPDATE_FILTER_DESTINATION,
    payload: null | DestinationReduced
}

interface UpdateFilterDestinationSearchAction {
    type: typeof UPDATE_FILTER_DESTINATION_SEARCH,
    payload: 'DESTINATION' | 'PARENT' | 'COUNTRY'
}

interface UpdateFilterDestinationTypeAction {
    type: typeof UPDATE_FILTER_DESTINATION_TYPE,
    payload: number
}

interface UpdateFilterLastAuthorAction {
    type: typeof UPDATE_FILTER_LAST_AUTHOR,
    payload: string
}

interface UpdateFilterModifiedDateGteAction {
    type: typeof UPDATE_FILTER_MODIFIED_DATE_GTE,
    payload: Date | null
}

interface UpdateFilterModifiedDateLteAction {
    type: typeof UPDATE_FILTER_MODIFIED_DATE_LTE,
    payload: Date | null
}

interface UpdateFilterParentAction {
    type: typeof UPDATE_FILTER_PARENT,
    payload: DestinationReduced[]
}

interface UpdateFilterPeriodAction {
    type: typeof UPDATE_FILTER_PERIOD,
    payload: 'CREATION' | 'MODIFICATION'
}

interface UpdateFilterPeriodTypeAction {
    type: typeof UPDATE_FILTER_PERIOD_TYPE,
    payload: number
}

interface UpdateFilterPicturesAction {
    type: typeof UPDATE_FILTER_PICTURES,
    payload: number
}

interface UpdateFilterStatusAction {
    type: typeof UPDATE_FILTER_STATUS,
    payload: 'ALL' | 'OFFLINE' | 'ONLINE_TO' | 'ONLINE_AGENCY'
}

interface UpdateGoogleIdAction {
    type: typeof UPDATE_GOOGLE_ID,
    payload: string
}

interface UpdateLatitudeAction {
    type: typeof UPDATE_LATITUDE,
    payload: string
}

interface UpdateListItemVisibilityAction {
    type: typeof UPDATE_LIST_ITEM_VISIBILITY,
    payload: Destination
}

interface UpdateLocationAction {
    type: typeof UPDATE_LOCATION,
    payload: {
        google_id:string,
        latitude:string,
        longitude:string
    }
}

interface UpdateLongitudeAction {
    type: typeof UPDATE_LONGITUDE,
    payload: string
}

interface UpdateMapAction {
    type: typeof UPDATE_MAP,
    payload: string
}

interface UpdateNameAction {
    type: typeof UPDATE_NAME,
    payload: string
}

interface UpdateNameErrorAction {
    type: typeof UPDATE_NAME_ERROR,
    payload: string
}

interface UpdateParentAction {
    type: typeof UPDATE_PARENT,
    payload: DestinationReduced | DestinationParent | null
}

interface UpdatePublishDateAction {
    type: typeof UPDATE_PUBLISH_DATE,
    payload: Date | string | null
}

interface UpdatePublishTimeAction {
    type: typeof UPDATE_PUBLISH_TIME,
    payload: Date | string | null
}

interface UpdateRatingAction {
    type: typeof UPDATE_RATING,
    payload: number | number[]
}

interface UpdateToUserAction {
    type: typeof UPDATE_TO_USER,
    payload: User | null
}

interface UpdateVisibilityAction {
    type: typeof UPDATE_VISIBILITY,
    payload: number
}
interface UpdateVideoLinkAction {
    type: typeof UPDATE_VIDEO_LINK,
    payload: string
}

interface UpdateEmailAction {
    type: typeof UPDATE_EMAIL,
    payload: string
}
interface UpdateZoomAction {
    type: typeof UPDATE_ZOOM,
    payload: number
}

export type DestinationActionTypes =
    SetColumnsAction |
    SetCheckingNameErrorAction |
    InitDestinationPictureAction |
    AddPreferencesAction |
    DeleteDestinationPictureAction |
    MoveDownColumnAction |
    MoveUpColumnAction |
    ResetAddDestinationAction |
    ResetFiltersAction |
    SetDestinationAction |
    SetDestinationVersionAction |
    SetEditStepAction |
    SetErrorsAction |
    SetExportTypeAction |
    SetLimitAction |
    SetListAction |
    SetOrderByAction |
    SetPageAction |
    SetPreferencesAction |
    SetRunningAction |
    SetSearchAction |
    ToggleCancelModalAction |
    ToggleColumnAction |
    ToggleDestinationPicturesOrderAction |
    ToggleExportAction |
    ToggleExportFullAction |
    ToggleFiltersAction |
    ToggleHomePageDisplayAction |
    ToggleAtSeaAction |
    ToggleNewAction |
    ToggleRefreshAction |
    UpdateCalendarIdAction |
    UpdateCategoryAction |
    UpdateCurrencyAction |
    UpdateDestinationNameLocaleAction |
    UpdateDestinationPictureOrderAction |
    UpdateDestinationSearchAction |
    UpdateDestinationTypeAction |
    UpdateDurationDaysAction |
    UpdateDurationHoursAction |
    UpdateDurationMinutesAction |
    UpdateFilterCountryAction |
    UpdateFilterCreatedDateGteAction |
    UpdateFilterCreatedDateLteAction |
    UpdateFilterCreatorAction |
    UpdateFilterDestinationAction |
    UpdateFilterDestinationSearchAction |
    UpdateFilterDestinationTypeAction |
    UpdateFilterLastAuthorAction |
    UpdateFilterModifiedDateGteAction |
    UpdateFilterModifiedDateLteAction |
    UpdateFilterParentAction |
    UpdateFilterPeriodAction |
    UpdateFilterPeriodTypeAction |
    UpdateFilterPicturesAction |
    UpdateFilterStatusAction |
    UpdateGoogleIdAction |
    UpdateLatitudeAction |
    UpdateListItemVisibilityAction |
    UpdateLocationAction |
    UpdateLongitudeAction |
    UpdateMapAction |
    UpdateNameAction |
    UpdateNameErrorAction |
    UpdateParentAction |
    UpdatePublishDateAction |
    UpdatePublishTimeAction |
    UpdateRatingAction |
    UpdateToUserAction |
    UpdateVisibilityAction |
    UpdateVideoLinkAction |
    UpdateEmailAction |
    UpdateZoomAction;